import Image from '@/components/atoms/Image';
import Heading, { HeadingLevels } from '@/components/atoms/legacy/Heading';
import {
  ArrowTrendingUpIcon,
  ChatBubbleLeftEllipsisIcon,
  SunIcon,
  UsersIcon,
} from '@heroicons/react/24/outline';

export const NewPartnerPageBenefits: React.FC = () => (
  <div
    className={`flex flex-col items-center py-[40px] m:py-[100px] lg:flex-row lg:px-[150px] lg:py-[40px]`}
  >
    <div className="relative mb-10 h-[345px] w-[352px] self-center m:h-[506px] m:w-[517px] lg:mb-0 lg:mr-[60px]">
      <Image
        src="/images/desktop-xl-ev-10.png"
        alt="A display of a car"
        fill
        className="object-contain"
      />
    </div>
    <div>
      <header className="flex flex-col">
        <div className="mb-10">
          <Heading
            className="mb-[6px] text-h3Regular text-blue-light m:text-display48px"
            level={HeadingLevels.H2}
          >
            Benefits of becoming{' '}
            <span className="text-brandElectric">a dealer partner</span>
          </Heading>
        </div>
      </header>
      <section className="mb-[40px] grid grid-cols-1 grid-rows-1 gap-[40px] text-body1Regular text-blue-light m:grid-cols-2 m:grid-rows-2 m:gap-[60px] l:mb-0">
        <p className="col-span-1">
          <UsersIcon className="mb-[10px] size-[28px] text-brandElectric" />
          Partner with EV.com to access a <span>large audience</span> of
          high-quality and serious EV buyers.
        </p>
        <p className="col-span-1">
          <ChatBubbleLeftEllipsisIcon className="mb-[10px] size-[28px] text-brandElectric" />
          EV.com offers a user-friendly platform that provides dealers with a
          simple and efficient way to{' '}
          <span>connect with potential buyers.</span>
        </p>
        <p className="col-span-1">
          <SunIcon className="mb-[10px] size-[28px] text-brandElectric" />
          <span>Build your brand image</span> early and get ahead in the EV
          market.
        </p>
        <p className="col-span-1">
          <ArrowTrendingUpIcon className="mb-[10px] size-[28px] text-brandElectric" />
          Take advantage of EV.com&apos;s{' '}
          <span>marketing and advertising expertise</span> to help drive more
          sales to your dealership.
        </p>
      </section>
    </div>
  </div>
);
